// Modules
import * as editorHTML from "editorjs-html";

import { serverUrl, filesystem_root, subdomain } from "../../../../../config";
import {
  alignment,
  animation,
  animationIndex,
  color,
  dimension,
  blockBgColor,
  headingToggle,
  overlayTool,
  draggable,
  fontSizeTune,
  mediaDraggable,
  blockPattern,
} from "../../../../../core/editorOptions";
import { processCellStyle } from "../../../../../utils/helpers";

import {
  AccordionArrow,
  HotelLocation,
  ReduceIcon,
  CloseIcon,
} from "../../../../../editorjs/icons/icons";
import contactImgDefault from "../../../../../assets/contact-img-default.jpg";

window.flipCard = function (element) {
  if (!element.classList.contains("flipped")) {
    element.classList.add("flipped");

    setTimeout(function () {
      element.classList.remove("flipped");
    }, 5000);
  } else {
    element.classList.remove("flipped");
  }
};

window.fullPic = function (element) {
  if (!element.classList.contains("full-pic")) {
    element.classList.add("full-pic");

    setTimeout(function () {
      element.classList.remove("full-pic");
    }, 5000);
  } else {
    element.classList.remove("full-pic");
  }
};

window.pillarToggle = function (element) {
  const target =
    element.parentElement.parentElement.parentElement.parentElement;
  if (target.classList.contains("active")) {
    target.classList.remove("active");
  } else {
    target.classList.add("active");
  }
};

window.textToggle = function (element) {
  const target = element.parentElement;
  if (target.classList.contains("active")) {
    target.classList.remove("active");
  } else {
    target.classList.add("active");
  }
};

window.hideModal = function (modalId) {
  const target = document.querySelector(`#${modalId}`);
  target.classList.remove("show");
};

window.showModal = function (modalId) {
  const target = document.querySelector(`#${modalId}`);
  if (target && !target.classList.contains("show")) {
    target.classList.add("show");
  }
};

window.imgTxtOverlayToggle = function (element, variant) {
  const container = element.closest(".content_block.image-text-overlay");
  if (variant === "close") {
    container.classList.remove("show");
  } else if (variant === "open") {
    if (!container.classList.contains("show")) {
      container.classList.add("show");
    }
  } else if (variant === "toggle") {
    if (!container.classList.contains("show")) {
      container.classList.add("show");
    } else {
      container.classList.remove("show");
    }
  }
};

const checkEmpty = (data) => {
  if (data.trim().length === 0) {
    return true;
  } else return false;
};

const assetUrlBuilder = (
  url,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
) => {
  let path = url;

  if (live) {
    if (isLibrarySlide && initial_presentation_id) {
      path = `${filesystem_root}/${subdomain}/presentations/${initial_presentation_id}/${initial_presentation_id}/${url}`;
    } else {
      path = `${filesystem_root}/${subdomain}/presentations/${presentation_id}/${presentation_id}/${url}`;
    }
  }

  return path;
};

// layout block parser
const editorLayoutParser = editorHTML({
  title: titleParser,
  subtitle: subtitleParser,
  blockHeading: blockHeadingParser,
  list: listParser,
  table: tableParser,
  quote: quoteParser,
  body: bodyParser,
  rule: ruleParser,
  image: imageParser,
  inlineImage: inlineImageParser,
  ancillary: ancillaryParser,
  icon: iconParser,
  video: videoParser,
  audio: audioParser,
  contact: contactParser,
  embed: embedParser,
  client: clientParser,
  point: pointParser,
  pillar: pillarParser,
  layout: layoutParser,
  buttonGroup: buttonGroupParser,
  imageTextOverlay: imageTextOverlayParser,
  captionedImage: captionedImageParser,
  chart: chartParser,
  map: () => {
    return "";
  },
  gallery: () => {
    return "";
  },
});

export function titleParser(block) {
  return checkEmpty(block?.data?.text)
    ? ""
    : `<h1 class="slide-title ${animation(block)} ${alignment(
        block,
      )}" style="${color(block)}; ${draggable(block)} ${fontSizeTune(block)}" ${animationIndex(block)}>${
        block?.data?.text
      }</h1>`;
}

export function subtitleParser(block) {
  return checkEmpty(block?.data?.text)
    ? ""
    : `<h2 class="slide-subtitle ${animation(block)} ${alignment(
        block,
      )}" style="${color(block)}; ${draggable(block)} ${fontSizeTune(block)}" ${animationIndex(block)}>${
        block?.data?.text
      }</h2>`;
}
export function blockHeadingParser(block) {
  return checkEmpty(block?.data?.text)
    ? ""
    : `<h4 class="slide-block-heading content_block ${animation(
        block,
      )} ${alignment(block)}" style="${color(block)}" ${animationIndex(block)}>${
        block?.data?.text
      }</h4>`;
}

export function listParser(block) {
  function createItems(block, items) {
    let itemsString = "";

    items?.forEach((element, index) => {
      if (!checkEmpty(element.content) || element.items.length !== 0) {
        itemsString =
          itemsString +
          `<li style="${color(block)} ${fontSizeTune(
            block,
          )}" class="${animation(block)} ${color(block) ? "li-custom" : ""}" ${animationIndex(block, index)}>${
            element.content
          } ${
            element.items.length !== 0 ? createItems(block, element.items) : ""
          }</li>`;
      }
    });

    return block?.data?.style === "ordered"
      ? `<ol>${itemsString}</ol>`
      : `<ul> ${itemsString}</ul>`;
  }

  return `
      <div class="list_block content_block ${alignment(
        block,
      )}" style="${draggable(block)}">
        ${createItems(block, block?.data?.items)}    
      </div>
    `;
}
export function tableParser(block, json, theme_json) {
  let rowContainer = "";
  const styled = block.data?.styled;
  const rowCount = block.data.content.length;

  const firstColumnWidthStyle = () => {
    if (
      block.data?.styled &&
      json?.reveal?.slideLayout?.id === "custom" &&
      styled.customFirstColWidth
    ) {
      return `grid-template-columns: minmax(5%, ${styled.firstColWidth}%);`;
    }
  };

  const firstRowHeightStyle = () => {
    if (
      block.data?.styled &&
      json?.reveal?.slideLayout?.id === "custom" &&
      styled.customFirstRowHeight
    ) {
      return `grid-template-rows: ${styled.firstRowHeight}% repeat(${
        rowCount - 1
      }, 1fr);`;
    }
  };

  if (
    json?.reveal?.slideLayout?.id === "healthcare-meeting-types" &&
    theme_json?.layouts.find((o) => {
      return o.id === "healthcare-meeting-types";
    })
  ) {
    let icons = json?.reveal?.slideLayout?.icons;

    if (theme_json && theme_json?.layouts) {
      let slideLayoutObj = theme_json?.layouts.find((o) => {
        return o.id === "healthcare-meeting-types";
      });

      icons = slideLayoutObj.icons;
    }

    block.data.content.forEach((row) => {
      let rowItems = "";
      if (row[1]) {
        const icon = icons.filter((obj) => {
          return obj.name === row[0];
        });

        if (icon[0]?.name === row[0]) {
          rowItems = `
              <div class="tc-cell">
                <div class="item-icon">${icon[0]?.icon}</div>
                <div class="">${row[0]}</div>
              </div>
              <div class="tc-cell">${row[1]}</div>`;
        } else {
          rowItems = `
              <div class="tc-cell">
                <div class="">${row[0]}</div>
              </div>
              <div class="tc-cell">${row[1]}</div>`;
        }

        rowContainer = rowContainer + `<div class="tc-row">${rowItems}</div>`;
      }
    });
  } else if (json?.reveal?.slideLayout?.id === "table-of-contents") {
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(currentUrl.split("?")[1]);
    const hash = urlParams.get("hash") ? urlParams.get("hash") : null;

    block.data.content.forEach((row) => {
      let rowItems = "";
      let slideNum = 1;
      let currentDomain = window.location.origin;
      let pathName = window.location.pathname.split("/");
      row.forEach((cell) => {
        if (cell.toLowerCase().match(/slide\s\d+/)) {
          slideNum = cell.match(/\d+/);
        }
        rowItems = rowItems + `<div class="tc-cell">${cell}</div>`;
      });

      let link = `${currentDomain}/${pathName[1]}/${pathName[2]}/${pathName[3]}`;

      if (hash) {
        const hashSplitted = hash.split("#");
        link = `${link}?hash=${hashSplitted[0]}`;
      }

      rowContainer =
        rowContainer +
        `<div class="tc-row"><a href=${link}#/${slideNum}>${rowItems}</a></div>`;
    });
  } else {
    // if (json?.reveal?.slideLayout?.id === 'data-table') {
    let dataTableObj = theme_json?.layouts.find((o) => {
      return o.id === "data-table";
    });
    let icons = dataTableObj?.icons;

    block.data.content.forEach((row, rowIndex) => {
      let rowItems = "";
      const cellCount = row.length;
      row.forEach((cell, cellIndex) => {
        const cellStyle = processCellStyle(
          rowCount,
          rowIndex,
          cellCount,
          cellIndex,
          block,
          json?.reveal?.slideLayout?.id,
        );

        if (cell.toLowerCase().match(/\?(.*)(?=\?)/) && icons) {
          let iconName = cell.toLowerCase().match(/\?(.*)(?=\?)/);
          let iconSVG = icons.find((el) => el.name === iconName[1]);
          if (iconName.length > 0 && iconSVG) {
            rowItems =
              rowItems +
              `<div class="tc-cell" style="${cellStyle}" ><div class="${iconSVG.name}-icon icon-container">${iconSVG.icon}</div></div>`;
          } else {
            rowItems =
              rowItems +
              `<div class="tc-cell" style="${cellStyle}" >${cell}</div>`;
          }
        } else {
          rowItems =
            rowItems +
            `<div class="tc-cell" style="${cellStyle}" >${cell}</div>`;
        }
      });
      rowContainer =
        rowContainer +
        `<div class="tc-row" style="${firstColumnWidthStyle()}" >${rowItems}</div>`;
    });
    // }
  }

  let headingClass = block?.data?.withHeadings ? "tc-table--heading" : "";

  if (json?.reveal?.slideLayout?.id === "custom") {
    return `<div class="tc-table ${headingClass} content_block ${animation(
      block,
    )} ${alignment(block)}" style="${color(block)} ${draggable(
      block,
    )} ${firstRowHeightStyle()}" ${animationIndex(block)}>
          ${rowContainer}
      </div>`;
  } else {
    return `<div class="tc-table ${headingClass} content_block ${animation(
      block,
    )} ${alignment(block)}" style="${color(block)} ${draggable(
      block,
    )}" ${animationIndex(block)}>${rowContainer}</div>`;
  }
}

export function quoteParser(block) {
  const quote =
    block?.data?.text !== ""
      ? `<blockquote class="${animation(block)} ${alignment(block)} ${
          color(block) ? "quote-custom" : ""
        }" style="${color(block)}" ${animationIndex(block)}>${block?.data?.text}</blockquote>`
      : "";

  return checkEmpty(block?.data?.text)
    ? ""
    : `
      <div class="quote-container content_block">
        <div class="quote-container">
          ${quote}
        </div>
      </div>`;
}

export function bodyParser(block, json) {
  let bodyBlocks = [];

  json?.blocks.forEach((_block) => {
    if (_block.type === "body") {
      bodyBlocks.push(_block);
    }
  });

  let bodyIndex = 0;
  bodyBlocks.forEach((_block, index) => {
    if (_block.id === block.id) {
      bodyIndex = index + 1;
    }
  });

  return checkEmpty(block?.data?.text)
    ? ""
    : `<div class="body_block content_block" style="${draggable(block)}" ${
        json.reveal.slideLayout.id === "factsheet"
          ? `data-block="${bodyIndex}"`
          : ""
      }>
        <p class="${animation(block)} ${alignment(block)}" style="${color(
          block,
        )} ${fontSizeTune(block)}" ${animationIndex(block)}>${block?.data?.text}</p>
      </div>`;
}
export function ruleParser(block) {
  return `<div class="rule_block content_block ${animation(block)} ${alignment(
    block,
  )}" style="${draggable(block)}" ><hr style="${color(block)}"  ${animationIndex(block)}/></div>`;
}
export function imageParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;

  if (url === "") {
    return "";
  }

  let imageBlocks = [];

  json?.blocks.forEach((_block) => {
    if (_block.type === "image") {
      imageBlocks.push(_block);
    }
  });

  let imageIndex = 0;
  imageBlocks.forEach((_block, index) => {
    if (_block.id === block.id) {
      imageIndex = index + 1;
    }
  });

  url = assetUrlBuilder(
    url,
    live,
    presentation_id,
    initial_presentation_id,
    isLibrarySlide,
  );

  const imageElement = `<img data-src="${url}" data-mid="${
    block?.data?.mid
  } alt="image" style="${
    overlayTool(block) ? `opacity: ${overlayTool(block).opacity}` : ""
  }"/>`;
  const x2 = `<img class="x2" data-src="${url}" data-mid="${
    block?.data?.mid
  } alt="image" style="${
    overlayTool(block) ? `opacity: ${overlayTool(block).opacity}` : ""
  }"/>`;

  if (json.reveal.slideLayout.id === "one-row-image") {
    return url !== ""
      ? `
        <div data-block="${imageIndex}" class="image_block content_block ${animation(
          block,
        )} ${alignment(block)}" ${animationIndex(block)}>
          ${imageElement}
          ${x2}
        </div>`
      : "";
  } else {
    return url !== ""
      ? `<div data-block="${imageIndex}" class="image_block content_block ${animation(
          block,
        )} ${alignment(block)}" ${
          json.reveal.slideLayout.id === "at-a-glance" ||
          json.reveal.slideLayout.id === "factsheet"
            ? 'onclick="fullPic(this);"'
            : ""
        } 
        style="${
          overlayTool(block)
            ? `background-color: ${overlayTool(block).backgroundColor};`
            : ""
        } ${mediaDraggable(block, json.reveal.slideLayout.id)}" ${animationIndex(block)}>
        <button class="full-pic-close-btn" ${
          json.reveal.slideLayout.id === "at-a-glance" && imageIndex === 1
            ? ""
            : 'onclick="fullPic(this)'
        }"> ${ReduceIcon}</button>
        ${imageElement}
      </div>`
      : "";
  }
}
export function inlineImageParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;
  if (url === "") {
    return "";
  }

  let imageBlocks = [];

  json?.blocks.forEach((_block) => {
    if (_block.type === "image") {
      imageBlocks.push(_block);
    }
  });

  let imageIndex = 0;
  imageBlocks.forEach((_block, index) => {
    if (_block.id === block.id) {
      imageIndex = index + 1;
    }
  });

  url = assetUrlBuilder(
    url,
    live,
    presentation_id,
    initial_presentation_id,
    isLibrarySlide,
  );

  const imageElement = `<img style="${dimension(
    block,
  )}" data-block="${imageIndex}" data-src="${url}" src="${url}" data-mid="${
    block?.data?.mid
  } alt="image" />`;
  return url !== ""
    ? `<div class="inline_image_block content_block ${animation(
        block,
      )} ${alignment(block)}" ${animationIndex(block)}>${imageElement}</div>`
    : "";
}
export function ancillaryParser(block) {
  const element =
    checkEmpty(block?.data?.heading) || checkEmpty(block?.data?.body)
      ? ""
      : `
      <div class="ancillary-content-container">
        <span class="ancillary-heading ancillary-content" style="${color(
          block,
        )}">
          ${block?.data?.heading}
        </span>
        <span class="ancillary-body ancillary-content" style="${color(block)}">
          ${block?.data?.body}
        </span>
      </div>
    `;

  return `<div class="ancillary-container ancillary_block ${animation(
    block,
  )} ${alignment(block)}" ${animationIndex(block)}>${element}</div>`;
}
export function iconParser(block, json) {
  const iconColor = block?.data?.color;
  let styles;

  if (iconColor) {
    styles = `color: ${iconColor}`;
  }

  const svg = `<div class="icon-container" style="${styles}">${block?.data?.icon}</div>`;
  return `<div class="icon_block content_block ${animation(block)} ${alignment(
    block,
  )}" style="${mediaDraggable(
    block,
    json.reveal.slideLayout.id,
  )}" ${animationIndex(block)}>${svg}</div>`;
}
export function videoParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = "";

  if (block?.data?.remote) {
    if (live) {
      url = block?.data?.original_url;
    } else {
      url = block?.data?.url;
    }
  } else {
    url = block?.data?.url;

    if (live) {
      url = assetUrlBuilder(
        url,
        live,
        presentation_id,
        initial_presentation_id,
        isLibrarySlide,
      );
    }
  }

  let poster;

  if (block?.data?.poster) {
    if (block?.data?.external || block?.data?.remote) {
      poster = block.data.poster;
    } else {
      poster = `${serverUrl}/api/video/thumbnail?mid=${block.data.mid}`;
    }
  }

  let videoElement;

  if (block?.data?.remote) {
    // Remote video (YouTube/Vimeo)
    videoElement = `
      <div class="plyr__video-embed" data-mid="${
        block.data.mid
      }" data-poster="${poster}">
        <iframe
          src="${url}"
          allowfullscreen
          allow="autoplay; encrypted-media"
          title="${block.data.name || "External Video"}"
        ></iframe>
      </div>
    `;
  } else {
    videoElement = `<video class="plyr" data-src="${url}" data-mid="${block?.data?.mid}" data-poster="${poster}" playsinline  controls><source src="${url}" type="video/mp4"></video>`;
  }

  return `<div class="video_block content_block ${animation(block)} ${alignment(
    block,
  )}" style="${mediaDraggable(
    block,
    json.reveal.slideLayout.id,
  )}" ${animationIndex(block)}>${videoElement}</div>`;
}
export function audioParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;

  if (url === "") {
    return "";
  }

  url = assetUrlBuilder(
    url,
    live,
    presentation_id,
    initial_presentation_id,
    isLibrarySlide,
  );

  const audioElement = `<audio data-src="${url}" data-mid="${block?.data?.mid}" controls />`;
  return `<div class="audio_block content_block ${animation(block)} ${alignment(
    block,
  )}" ${animationIndex(block)}>${audioElement}</div>`;
}

export function contactParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  const address =
    block?.data?.address?.length > 0 ? block?.data?.address : null;
  const email = block?.data?.email?.length > 0 ? block?.data?.email : null;
  const linkedin =
    block?.data?.linkedin?.length > 0 ? block?.data?.linkedin : null;
  const name = block?.data?.name?.length > 0 ? block?.data?.name : null;
  const phone = block?.data?.phone?.length > 0 ? block?.data?.phone : null;
  const title = block?.data?.title?.length > 0 ? block?.data?.title : null;
  const twitter =
    block?.data?.twitter?.length > 0 ? block?.data?.twitter : null;
  let url = block?.data?.url;
  let addressElement = ``;
  let emailElement = ``;
  let linkedinElement = ``;
  let nameElement = ``;
  let phoneElement = ``;
  let titleElement = ``;
  let twitterElement = ``;
  let defaultContactImg = contactImgDefault;

  if (live) {
    url = assetUrlBuilder(
      url,
      live,
      presentation_id,
      initial_presentation_id,
      isLibrarySlide,
    );

    if (url === "") {
      url = `${defaultContactImg}`;
    }
  } else {
    url = url !== "" && url !== filesystem_root ? url : `${defaultContactImg}`;
  }

  const imageElement = `<img class="cdx-contact" data-src="${url}" src="${url}" data-mid="${block?.data?.mid} alt="image" />`;

  if (address) {
    addressElement = `<a target="_blank" class="cdx-contact-input address" href="https://maps.google.com/?q=${address}">${address}</a>`;
  }

  if (email) {
    emailElement = `<a target="_blank" class="cdx-contact-input contact-email" href="mailto:${email}">${email}</a>`;
  }

  if (linkedin) {
    linkedinElement = `<a target="_blank" class="cdx-contact-input linkedin" href="${linkedin}">Connect on LinkedIn</a>`;
  }

  if (name) {
    nameElement = `<h4 class="cdx-contact-input name">${name}</h4>`;
  }

  if (phone) {
    phoneElement = `<a target="_blank" class="cdx-contact-input contact-number" href="tel:${phone}">${phone}</a>`;
  }

  if (title) {
    titleElement = `<h6 target="_blank" class="cdx-contact-input title">${title}</h6>`;
  }

  if (twitter) {
    twitterElement = `<a target="_blank" class="cdx-contact-input twitter" href="https://twitter.com/${twitter}">@${twitter}</a>`;
  }

  return `
      <div class="contact-block content_block ${animation(block)} ${alignment(
        block,
      )}" ${animationIndex(block)}>
        <div class="cdx-contact-container">
            ${imageElement}
            <div class="cdx-contact-info-container">
              ${nameElement}
              ${titleElement}
              ${phoneElement}
              ${emailElement}
              ${linkedinElement}
              ${twitterElement}
              ${addressElement}
          </div>
        </div>
      </div>
    `;
}
export function embedParser(block) {
  const element = `<div class="embed-container"><div class="embed">${block.data.code}</div></div>`;
  return `<div class="embed content_block ${animation(block)} ${alignment(
    block,
  )}" style="${draggable(block)}" ${animationIndex(block)}>${element}</div>`;
}
export function mapParser(
  block,
  live,
  slide,
  json,
  theme_json,
  themeDirectory,
) {
  let html;

  const apiKey = theme_json?.googleApiKey;

  if (apiKey) {
    let pinSrc = `${themeDirectory}/dist/images/icons/${theme_json?.icons?.pin}`;

    if (live) {
      pinSrc = `${themeDirectory}/dist/images/icons/${theme_json?.icons?.pin}`;
    }

    const label = encodeURIComponent(block?.data?.label);
    const params = `key=${apiKey}&lat=${block?.data?.latitude}&lng=${
      block?.data?.longitude
    }&label=${label}&pin=${pinSrc}&zoom=${block?.data?.zoomLevel ?? 16}${
      json.reveal.slideLayout.id === "custom" ? "&layout=draggable" : ""
    }`;
    html = `<iframe data-src="/map.html?${params}" />`;
  } else {
    html =
      '<div class="d-flex h-100 justify-content-center align-items-center"><b>Map can\'t be displayed - API key error</b></div>';
  }

  const tag = document.createElement("div");
  tag.classList.add("w-100");
  tag.classList.add("h-100");
  tag.setAttribute("id", `map-${slide.id}`);

  tag.innerHTML = html;

  const container = document.createElement("div");
  container.appendChild(tag);
  const data = container.innerHTML || "";

  return `
      <div class="map" style="${draggable(block)}">
        <div class="map-container ${animation(block)} ${alignment(
          block,
        )}" ${animationIndex(block)}>${data}</div>
      </div>`;
}

export function clientParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;
  let image = "";

  if (url !== "") {
    url = assetUrlBuilder(
      url,
      live,
      presentation_id,
      initial_presentation_id,
      isLibrarySlide,
    );

    image = `<img data-src="${url}" alt="image" />`;
  }

  const element = `<div class="cdx-client" onclick="flipCard(this);">
        <div class="front">${image}</div>
        <div class="back"><p>${block?.data?.text}</p></div>
      </div>`;

  return `<div class="client content_block ${animation(block)} ${alignment(
    block,
  )}" ${animationIndex(block)}>${element}</div>`;
}
export function pointParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;
  let image = "";
  let altIndexText = "";

  if (url !== "") {
    url = assetUrlBuilder(
      url,
      live,
      presentation_id,
      initial_presentation_id,
      isLibrarySlide,
    );

    image = `<img data-src="${url}" alt="image" />`;
  }

  if (block?.data?.altIndex) {
    altIndexText = `<h1 class="point-alternate" style="${color(block)}">${
      block?.data?.altIndexText
    }</h1>`;
  }

  const element = `
      <div class="point-img-container ${
        block?.data?.altIndex ? "alt-index" : ""
      }">
        ${block?.data?.altIndex ? altIndexText : image}
      </div>
      <div class="point-content-container">
        <h4 class="point-heading" style="${color(block)}">
          ${block?.data?.heading}
        </h4>
        <p class="point-body" style="${color(block)}">
          ${block?.data?.body}
        </p>
      </div>
    `;

  return `<div class="point-container point_block ${animation(
    block,
  )} ${alignment(block)} ${
    block?.data?.orientation ? "column" : ""
  }" style="${mediaDraggable(
    block,
    json.reveal.slideLayout.id,
  )}" ${animationIndex(block)}>${element}</div>`;
}
export function pillarParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;
  let imgElement = "";

  if (url !== "") {
    url = assetUrlBuilder(
      url,
      live,
      presentation_id,
      initial_presentation_id,
      isLibrarySlide,
    );

    imgElement = `<img data-src="${url}" alt="" class="media-wrapper"/>`;
  }
  const headingElement = `<div class="heading-container"> <h4 class="heading-title" style="${color(
    block,
  )}">${block.data.heading}</h4></div>`;
  const subHeadingElement = block.data.subHeading
    ? `<div class="sub-heading-container"> <h6 class="heading-sub-title" style="${color(
        block,
      )}">${block.data.subHeading}</h6></div>`
    : "";
  const bodyElement = `<div class="body-container"> <div class="body-redactor"><p class="body" style="${color(
    block,
  )}">${block.data.body}</p></div></div>`;
  const accordToggleBtn = `<button class="accord-toggle" onclick="pillarToggle(this);">${AccordionArrow}</button>`;
  const headerContainer = `
    <div class="header-container">
      <div class="header-redactor ${headingToggle(block)}"
        ${
          !block.data.subHeading &&
          json.reveal.slideLayout.id === "four-column-accordion-image"
            ? 'style="justify-content: flex-end;"'
            : ""
        }
      >
        ${headingElement}
        ${subHeadingElement}
        ${accordToggleBtn}
      </div>
    </div>`;
  const element = `
      <div class="content_block pillar_block">
        ${imgElement}
        <div class="text-container ${
          blockPattern(block) ?? blockBgColor(block)
        }">
          <div class="text-redactor">
            ${headerContainer}
            ${bodyElement}
          </div>
        </div>
      </div>
      `;

  return element;
}
export function layoutParser(block, json) {
  let layoutEditorBlocks = block.data.itemContent[1];
  const toggleBtn = `<button class="toggle-btn" onclick="textToggle(this);">${AccordionArrow}</button>`;
  return `
      <div class="content_block layout_block">
        ${
          json?.reveal?.slideLayout?.id === "one-column-text-toggle"
            ? toggleBtn
            : ""
        }
        <div class="layout_block_redactor">
          ${editorLayoutParser.parse(layoutEditorBlocks).join("")}
        </div>
      </div>`;
}
export function popupParser(block, slide) {
  const popupHeading = `<h3 class="popup-heading">${block?.data?.heading}</h3>`;
  const contentType = block?.data?.contentType;
  const listType = block?.data?.listType;
  let listItems = "";

  if (contentType === "list") {
    if (block?.data?.list.length > 0) {
      block?.data?.list.forEach((e) => {
        listItems = listItems + `<li class="popup-list-item">${e}</li>`;
      });
    }
  }

  let list =
    listType === "ordered"
      ? `<ol class="popup-list">${listItems}</ol>`
      : `<ul class="popup-list">${listItems}</ul>`;

  return `
      <div id="modal-${slide.id}-${
        block?.data?.modalId
      }" class="modal_block content_block popup-modal-container">
        <div class="popup-backdrop"></div>
        <div class="popup-modal">
          <div class="popup-modal-heading-container">
            ${popupHeading}
            <button class="popup-close" onclick="hideModal('modal-${slide.id}-${
              block?.data?.modalId
            }')">${CloseIcon}</button>
          </div>
          <div class="popup-modal-content-container">
            <div class="popup-modal-content">
              ${
                contentType === "text"
                  ? `<p class="popup-body">${block?.data?.body}</p>`
                  : `${list}`
              }
            </div>
          </div>
        </div>
      </div>`;
}
export function buttonGroupParser(block) {
  const blockData = block.data.buttonData;
  const buttonItem = (e) => {
    return `
      <div class="btn-item-container">
        <a href="${
          e.url
        }" class="btn-item-link-wrapper" target="_blank" rel="noopener noreferrer">
          <button class="btn-item" style="width: ${block.data.buttonWidth}${
            block.data?.percentage ? "%" : "px"
          };">${e.text}</button>
        </a>
      </div>
      `;
  };

  let buttons = "";

  blockData.forEach((e) => {
    buttons = buttons + buttonItem(e);
  });

  return `
    <div class="content_block button-group_block ${
      block.data.single ? "single" : ""
    }"  style="${draggable(block)}">
      <div class="btn-group-container">
        ${buttons}
      </div>
    </div>
    `;
}
export function locationHeaderParser(block) {
  let data = block?.data;
  let locationIcon = `
      <div class="location-pin-icon">
        ${HotelLocation}
      </div>
    `;
  let hotelCountry = `
      <h6 class="hotel-country">
        ${data.country}
      </h6>
    `;
  let hotelCity = `
    <h6 class="hotel-city">
      ${data.city}
    </h6>
  `;
  let hotelName = `
    <h6 class="hotel-name">
      ${data.hotelName}
    </h6>
  `;
  let hotelHeading = `
    <div class="hotel-heading-container">
      <div class="hotel-heading-content-container">
        ${locationIcon}
        ${hotelCountry}
        ${hotelCity}
        ${hotelName}
      </div>
    </div>
    `;

  return hotelHeading;
}
export function hotelCapacityParser(block) {
  let data = block?.data;

  let makeGroup = (value, label, groupName) => {
    return `
        <div class="hotel-capacity-group ${groupName}-group">
          <div class="hotel-capacity-value">
            ${value}
          </div>
          <div class="hotel-capacity-label">
            ${label}
          </div>
        </div>
      `;
  };

  let hotelCapacity = `
    <div class="hotel-capacity-container">
      <div class="hotel-capacity-content-container">
      ${makeGroup(data.guestRoom, "GUEST<br>ROOMS", "guest-rooms")}
      ${makeGroup(data.meetingRooms, "MEETING<br>ROOMS", "meeting-rooms")}
      ${makeGroup(data.maxCap, "MAX<br>CAP", "max-cap")}
      ${makeGroup(
        data.exhibitSpace,
        "EXHIBITION<br>SPACE SQM",
        "exhibit-space",
      )}
      ${makeGroup(data.suites, "SUITES", "suites")}
      ${makeGroup(data.familyRooms, "FAMILY<br>ROOMS", "family-rooms")}
      ${makeGroup(data.restaurants, "RESTAURANTS", "restaurants")}
      ${makeGroup(data.bars, "BARS", "bars")}
      ${makeGroup(data.spa, "SPA", "spa")}
      ${makeGroup(data.gym, "GYM", "gym")}
      ${makeGroup(data.pool, "POOL", "pool")}
      ${makeGroup(data.parking, "PARKING", "parking")}
      ${makeGroup(data.freeWifi, "FREE<br>WIFI", "free-wifi")}
      ${makeGroup(
        data.breakfastBuffet,
        "BREAKFAST<br>BUFFET",
        "breakfast-buffet",
      )}
      ${makeGroup(
        data.expressCheckout,
        "EXPRESS<br>CHECK-OUT",
        "express-checkout",
      )}
      </div>
    </div>
    `;

  return hotelCapacity;
}
export function locationFooterParser(block) {
  let data = block?.data;
  let locationContainer = `
      <div class="hotel-footer-location-container">
        <p class="hotel-footer-location-label">
          LOCATION:
        </p>
        <p class="hotel-footer-location">
          ${data.location.text}
        </p>
      </div>
    `;
  let hotelUrl = `
      <a href="${data.hotelUrl}" class="hotel-footer-url">VISIT HOTEL WEBSITE</a>
    `;
  let locationFooter = `
      <div class="hotel-footer-container">
        <div class="hotel-footer-content-container">
          ${locationContainer}
          ${hotelUrl}
        </div>
      </div>
    `;

  return locationFooter;
}
export function hotelTextOverlayParser(block) {
  let logo =
    block.data.logo.svg !== ""
      ? `<div class="hotel-logo-container">${block.data.logo.svg}</div>`
      : "";
  let heading = `<h4 class="overlay-heading">${block.data.heading}</h4>`;
  let body = `<p class="overlay-body">${block.data.body}</p>`;

  let container = `<div class="content_block hotelTextOverlay"><div class="hotel-text-overlay-content-container">${logo}${heading}${body}</div></div>`;
  return container;
}
export function imageTextOverlayParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let heading = block.data.heading === "<br>" ? "" : block.data.heading;
  let body = block.data.body === "<br>" ? "" : block.data.body;
  const processUrl = (_url) => {
    let url = _url;

    if (url === "") {
      return "";
    }

    url = assetUrlBuilder(
      url,
      live,
      presentation_id,
      initial_presentation_id,
      isLibrarySlide,
    );

    return url;
  };

  let imageTextOverlayBlocks = [];

  json?.blocks.forEach((_block) => {
    if (_block.type === "imageTextOverlay") {
      imageTextOverlayBlocks.push(_block);
    }
  });

  let itemIndex = 0;
  imageTextOverlayBlocks.forEach((_block, index) => {
    if (_block.id === block.id) {
      itemIndex = index + 1;
    }
  });

  let showOverlayBtn = `<button class="img-txt-overlay-toggle-btn" onclick="imgTxtOverlayToggle(this, '${
    block.data.toggleOption ? "toggle" : "open"
  }')">${
    block.data.heading
  }<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"> <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" /> </svg></button>`;
  let contentContainer = `
    <div class="img-txt-overlay-content-container">
    ${
      block.data.toggleOption
        ? ""
        : `
      <button class="img-txt-overlay-content-close-btn" onclick="imgTxtOverlayToggle(this, 'close')">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
          <path
            d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
        </svg>
      </button>
      `
    }
      <h4 class="img-txt-overlay-content-title">${heading}</h4>
      <p class="img-txt-overlay-content-body">${body}</p>
    </div>`;
  const imageContainer = `<div class="img-txt-overlay-image-container">
      <img src="${processUrl(
        block.data?.images?.[0]?.url,
      )}" alt="" class="img-txt-overlay-primary-image">
      ${
        block.data.secondaryImage
          ? `<img src="${processUrl(
              block.data?.images?.[1]?.url,
            )}" alt="" class="img-txt-overlay-secondary-image">`
          : ""
      }
    </div>`;
  if (json.reveal.slideLayout.id === "static-gallery") {
    if (heading === "" && body === "") {
      showOverlayBtn = "";
      contentContainer = "";
    }
  }
  const container = `
    <div class="content_block image-text-overlay ${
      block.data.secondaryImage ? "has-secondary" : ""
    }" data-block="${itemIndex}">
      ${showOverlayBtn}
      ${contentContainer}
      ${imageContainer}
    </div>`;

  return container;
}
export function captionedImageParser(
  block,
  live,
  presentation_id,
  initial_presentation_id,
  isLibrarySlide,
  json,
) {
  let url = block?.data?.url;

  if (url === "") {
    return "";
  }

  let imageBlocks = [];

  json?.blocks.forEach((_block) => {
    if (_block.type === "captionedImage") {
      imageBlocks.push(_block);
    }
  });

  let imageIndex = 0;
  imageBlocks.forEach((_block, index) => {
    if (_block.id === block.id) {
      imageIndex = index + 1;
    }
  });

  url = assetUrlBuilder(
    url,
    live,
    presentation_id,
    initial_presentation_id,
    isLibrarySlide,
  );

  const imageElement = `<img data-src="${url}" data-mid="${
    block?.data?.mid
  } alt="image" style="${
    overlayTool(block) ? `opacity: ${overlayTool(block).opacity}` : ""
  }"/>`;
  const caption = `<p class="caption">${block.data.caption}</p>`;

  return url !== ""
    ? `<div data-block="${imageIndex}" class="captioned_image_block content_block ${animation(
        block,
      )} ${alignment(block)}" style="${
        overlayTool(block)
          ? `background-color: ${overlayTool(block).backgroundColor};`
          : ""
      } ${draggable(block)}" ${animationIndex(block)}>
          ${imageElement}
          ${caption}
        </div>`
    : "";
}
export function shapeParser(block) {
  let svg = "";
  if (block.data.shape === "rect") {
    const shapeProperties = block.data;
    const shape = (main) =>
      `<rect width="100%" height="100%" 
        ${
          block.data?.shapeRadius
            ? `rx="${shapeProperties.shapeRadius}" ry="${shapeProperties.shapeRadius}"`
            : ""
        } 
        ${
          main
            ? `clip-path="url(#SvgjsClipPath${block.id})" stroke-width="${
                shapeProperties?.shapeBorder || 0
              }" stroke="${
                shapeProperties?.shapeBorderColor || "#00000000"
              }" fill="${shapeProperties?.shapeFill}"`
            : ""
        }></rect>`;

    svg = `
          ${shape(true)}
          <defs>
            <clipPath id="SvgjsClipPath${block.id}">
              ${shape(false)}
            </clipPath>
          </defs>
      `;
  }
  if (block.data.shape === "circle") {
    const shapeProperties = block.data;
    const shape = (main) =>
      `<rect width="100%" height="100%" 
        ${block.data?.shapeRadius ? `rx="100%" ry="100%"` : ""} 
        ${
          main
            ? `clip-path="url(#SvgjsClipPath${block.id})" stroke-width="${
                shapeProperties?.shapeBorder || 0
              }" stroke="${
                shapeProperties?.shapeBorderColor || "#00000000"
              }" fill="${shapeProperties?.shapeFill}"`
            : ""
        }></rect>`;

    svg = `
          ${shape(true)}
          <defs>
            <clipPath id="SvgjsClipPath${block.id}">
              ${shape(false)}
            </clipPath>
          </defs>
      `;
  }

  return `<div class="shape-block ${animation(block)}" style="${draggable(block)}" ${animationIndex(block)}>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%">
          ${svg}
        </svg>
      </div>`;
}
export function chartParser(block) {
  return `<div class="chart-block" style="${draggable(block)}">
  <canvas data-chart-id="${block.id}"></canvas>
  </div>`;
}
